import { render } from "./CheckoutSummary.vue?vue&type=template&id=72d6c55e"
import script from "./CheckoutSummary.vue?vue&type=script&lang=js"
export * from "./CheckoutSummary.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrei/Desktop/EO LARAVEL/club-shops-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__